import {ReduxStateType} from '../store';

export const selectBusinessDetails = (state: ReduxStateType) => {
  return state.businessDetails;
};
